import { Outlet } from "react-router";
import PageTransition from "@/components/page-transition";

export default function LayoutGlobal() {
	return (
		<div className="flex h-screen">
			<main className="flex-1 overflow-auto p-8 bg-[#fafafa]">
				<div className="max-w-[960px] mx-auto">
					<PageTransition>
						<Outlet />
					</PageTransition>
				</div>
			</main>
		</div>
	);
}
